export default __webpack_public_path__ + "static/media/photo4.7e6c0dba.jpg";